import styled from 'styled-components';

export const StyledNav = styled.div`
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    border-bottom: 1px solid black;
    background-color: #1F1F1F;
    box-shadow: 0 2px 10px 2px rgb(0 0 0 / 50%);
`;

export const NavMenu = styled.div`
    display: flex;
    
    @media (max-width: 992px) {
        display: none;
    }
    
    &.active {
        width: 100%;
        margin-top: 280px;
        background-color: #1F1F1F;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        border-top: 1px solid black;
    }
`;

export const WebsiteName = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none!important;    
    position: absolute;
    left: 0;
    
    @media (max-width: 992px) {
        transform: scale(0.8);
    }
    
    @media (max-width: 370px) {
        transform: scale(0.7);
        left: -20px;
    }
`;

export const NavText = styled.span`
    color: white;
    font-family: Roboto Condensed, serif;
    margin-left: 8px;
    font-size: 16px;
`;

export const ColoredText = styled.span`
    color: ${({color}) => color};
    font-weight: ${({fontWeight}) => fontWeight ?? 'bold'};
`;
